// src/components/courses/CourseTrainerCard.jsx
import React from 'react';
import styles from './CourseTrainerCard.module.css';

// Import all Font Awesome icons you might use for trainers
import {
  FaUserTie,       // Generic professional
  FaLaptopCode,     // Web Development, Programming
  FaBrain,          // AI, Data Science, Machine Learning
  FaCloud,          // Cloud, DevOps
  FaBug,            // Testing, QA
  FaShieldAlt,      // Cybersecurity
  FaChartLine,      // Data Analysis, Business Intelligence
  FaPalette,        // UI/UX Design
  FaCogs,           // Automation, DevOps
  FaServer,         // Cloud Infrastructure
  FaGraduationCap   // Default/General Trainer
} from 'react-icons/fa'; // Import all icons you might need

// Map icon names (strings) to their actual React components
const TrainerIconMap = {
  FaUserTie,
  FaLaptopCode,
  FaBrain,
  FaCloud,
  FaBug,
  FaShieldAlt,
  FaChartLine,
  FaPalette,
  FaCogs,
  FaServer,
  FaGraduationCap, // Fallback icon
};

const CourseTrainerCard = ({ trainer }) => {
  // Get the icon component from the map, or use a default if not found
  const IconComponent = TrainerIconMap[trainer.icon] || TrainerIconMap.FaGraduationCap;

  return (
    <div className={styles.trainerCard}>
      {/* Render the dynamic IconComponent instead of an <img> tag */}
      <div className={styles.trainerIconWrapper}>
        <IconComponent className={styles.trainerIcon} />
      </div>
      <h3>{trainer.name}</h3>
      <p className={styles.expertise}>{trainer.expertise}</p>
      <p className={styles.bio}>{trainer.bio}</p>
    </div>
  );
};

export default CourseTrainerCard;